"use strict";


/**
* Контекстное меню.
* Отображается по нажатию левой кнопкой мыши на элемент. После отображения не может быть изменено.
* Для создания другого набора элементов следует использовать новый объект.
*
* @class WebAccess.components.menus.BaseContextMenu
* @since 5.0.0.4000
* @extends BaseObject
* @param {string} itemSelector Существующий элемент страницы
* @param {WebAccess.components.menus.BaseContextMenu.contextMenuItem} [opt_menuItems] Массив со списком пунктов меню
* @param {WebAccess.components.menus.BaseContextMenu.contextMenuSettings} [opt_settings] Параметры контекстного меню
* @throws ERR_ELEMENT_DOES_NOT_EXIST - указанного элемента страницы не существует.
* @fires Следует использовать параметр itemSelect с передачей выбранного элемента.
* @example
* function CreateReferenceFiltersMenu(selector, data) {
*  var menu = new WA.components.menus.BaseContextMenu(selector,data);
*      menu.render();
*      menu.bind("itemSelect", function(item) {
*       grid.PerformCallback(['CHANGEFILTER', item.name, item.label]);
*        $(selector).html(item.label);
*      });
*  };
*/

/**
 * Пункт меню.
 * @typedef {Object} WebAccess.components.menus.BaseContextMenu.contextMenuItem
 * @since 5.0.0.4000
 * @property {string} name Имя пункта меню
 * @property {string} label Заголовок пункта меню
 * @property {string} [icon] Иконка рядом с заголовком
 * @property {boolean} [bottomSeparator] Признак необходимости добавления разделителя ниже пункта меню
 * @property {boolean} [selected] Признак того, что объект выбран
 * @property {string} [tooltip] Подсказка при наведенииы
 * @example
 * var menuItems = [
 *     {"name": "-1",
 *      "label": L("DEFAULT_EMPTY_FILTER"),
 *      "bottomSeparator": true
 *     }];
 */

/**
 * Параметры контекстного меню.
 * @typedef {Object} WebAccess.components.menus.BaseContextMenu.contextMenuSettings
 * @since 5.0.0.4000
 * @property {string} [shiftY] Величина верхнего отступа
 * @property {string} [width] Ширина меню
 * @property {function} [onShow] Ссылка на функцию, которая будет выполнена при отображении меню
 * @property {function} [onHide] Ссылка на функцию, которая будет выполнена при скрытии меню
 * @example
 * var settings = [
 *     {"shiftY": 100,
 *      "width": 300,
 *      "onShow": function( ) { alert("onShow"); }
 *     }];
 */
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
//
(function (global) {
  var BaseContextMenu = BaseObject.extend({

    className: 'BaseContextMenu',
    items: [],
    settings: {},
    _imageWidth: 16,
    _imageHeight: 16,
    _isRendered: false,
    _menu: null,

    init: function (itemSelector, opt_menuItems, opt_settings) {
      log.info('CONTEXT_MENU', 'Init context menu for ' + itemSelector);
      var instance = this;

      this.items = (!!opt_menuItems) ? opt_menuItems : [];
      this.settings = { imageWidth: this._imageWidth, imageHeight: this._imageWidth };
      if (!$.isEmptyObject(opt_settings)) $.extend(this.settings, opt_settings);

      this._super(itemSelector);
      this._jObject = $(itemSelector);
      if (this._jObject.length <= 0) WA.raise("ERR_ELEMENT_DOES_NOT_EXIST", itemSelector);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _makeMenuObject: function () {
      var me = this;
      //if (!!this._menu) return this;
      for (var i = 0; i < me.items.length; ++i) {
        me.items[i].text = escapeHtml(me.items[i].label).trunc(50) || me.items[i].text; //чтобы было как везде, ближе к эталонам
        me.items[i].image = me.items[i].icon;
        me.items[i].hoverImage = me.items[i].hoverIcon;
        if (me.items[i].selected && !me.items[i].image) {
          me.items[i].image = "/App_Sprites/menu_check.png";
        }
        me.items[i].onClick = (!!me.items[i].onClick) ? me.items[i].onClick : function (item, menu, event) { me.fire("itemSelect", item, menu, event); };
      }
      this._menu = new ContextMenu(this.items, this.settings);
      return this;
    },

    /**
     * Добавить новый пункт меню.
     * @method WebAccess.components.menus.BaseContextMenu#addItem
     * @param {string} name Имя пункта меню
     * @param {string} label Заголовок пункта меню
     * @param {string} [opt_icon] Значок рядом с заголовком
     * @param {boolean} [opt_bottomSeparator] Признак необходимости добавления разделителя после пункта меню
     * @param {boolean} [opt_selected] Признак того, что объект выбран
     * @param {boolean} [opt_disabled] Признак того, что объект доступен
     * @throws ERR_OBJECT_IS_ALREADY_RENDERED - объект уже отображен.
     * @return {WebAccess.components.menus.BaseContextMenu} Объект типа BaseContextMenu.
     * @todo Возможность принятия WebAccess.components.menus.contextMenuItem.
     */
    addItem: function (name, label, opt_icon, opt_bottomSeparator, opt_selected, opt_disabled, opt_tooltip) {
      if (!this._isRendered) {
        var instance = this;
        this.items.push({
          'name': name,
          'label': escapeHtml(label).trunc(50),
          "image": opt_icon,
          "bottomSeparator": (opt_bottomSeparator || false),
          "selected": (opt_selected || false),
          "disabled": (opt_disabled || false),
          "tooltip": (opt_tooltip || '')
        });
        return this;
      } else {
        return WA.raise("ERR_OBJECT_IS_ALREADY_RENDERED");
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить выбранный пункт меню.
    * @method WebAccess.components.menus.BaseContextMenu#getSelectedItem
    * @return {WebAccess.components.menus.BaseContextMenu.contextMenuItem} Объект типа BaseContextMenu.contextMenuItem.
    */
    getSelectedItem: function () {
      return this.items[getElementIndexByAttr(this.items, "selected", true)];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить выбранный пункт меню.
    * @method WebAccess.components.menus.BaseContextMenu#setSelectedItem
    * @param {string} name Имя пункта меню.
    * @param {boolean} isSelected Выбран или нет пункт меню.
    * @param {string} opt_icon Новая иконка.
    * @return {WebAccess.components.menus.BaseContextMenu} Объект типа BaseContextMenu.
    */
    setSelectedItem: function (name, isSelected, opt_icon, opt_iconCSSClass) {
      var me = this;

      isSelected = (isSelected !== false);

      var item = me.items[getElementIndexByAttr(me.items, "name", name)];
      item.selected = isSelected;
      item.icon = _.isUndefined(opt_icon) ? item.icon : opt_icon;
      item.image = item.icon;
      if (isSelected) {
        if (!item.image) {
          item.image = "/App_Sprites/menu_check.png";
        } else if (opt_iconCSSClass) {
          item.iconCSSClass = opt_iconCSSClass;
        }
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отображает меню.
     * Метод может быть вызван только один раз – когда все пункты меню уже переданы.
     * @method WebAccess.components.menus.BaseContextMenu#render
     * @throws ERR_OBJECT_IS_ALREADY_RENDERED - объект уже отображен.
     * @return {WebAccess.components.menus.BaseContextMenu} Объект типа BaseContextMenu.
     */
    render: function (force) {
      var me = this;
      if (!!me._isRendered && !force) return WA.raise("ERR_OBJECT_IS_ALREADY_RENDERED");
      this._makeMenuObject();
      this._isRendered = true;
      this._jObject.contextMenu(this._menu);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отобразить меню. (Альтернативыный способ, c исходного события)
    * @method WebAccess.components.menus.BaseContextMenu#show
    * @param {object} [opt_event] DOM-событие вызывающее данный метод
    * @return {WebAccess.components.menus.BaseContextMenu} Объект типа BaseContextMenu.
    * @since  5.2.0.1300
    */
    show: function (opt_event) {
      this._makeMenuObject();
      this._menu.show(null, null, opt_event);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отобразить меню в указанных координатах.
    * @method WebAccess.components.menus.BaseContextMenu#showAt
    * @param {integer} x Координата по горизонтали
    * @param {integer} y Координата по вертикали
    * @param {object} [opt_event] DOM-событие вызывающее данный метод
    * @return {WebAccess.components.menus.BaseContextMenu} Объект типа BaseContextMenu.
    * @since  5.2.0.1300
    */
    showAt: function (x, y, opt_event) {
      this._makeMenuObject();
      this._menu.showAt({ left: x, top: y }, null, null, opt_event);
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.BaseContextMenu = BaseContextMenu;
})(window.WebAccess.components.menus);
